module.exports = __webpack_public_path__ + "static/media/29EUNOG10.d55bc04e.jpg";